import React from 'react';
import ReactDOM from 'react-dom';
import { ThemeProvider, Modal, ModalContent } from '@workboard/wobo-ui';
import styled from "styled-components"
import { CheckBoxComp } from '../../inputs/fields.component';
import SearchBoxComp from '../../inputs/searchbox.component';
import {PublishSearchBoxList,RollUpTableComp,TeamSelectedComp} from '../wizard/key_results/rolluptable.component';
import GoalServices from "../../../services/goal.services";
import {withTranslation} from 'react-i18next';
import { okrDetailConstants } from '../../../constants/okr/okrDetails.constants';
import { eventKeyConstants , KeyDownEvent} from '../../../utils/eventKey'

const StyledModal = styled(Modal)`
  ${ModalContent} { 
    padding: 0px !important;
  }
`;

const okrPublishPopup = (attrs) => {
    if (document.getElementById('publish-print-goal-box')) {
        ReactDOM.unmountComponentAtNode(document.getElementById('publish-print-goal-box'));
    }
    ReactDOM.render(<ViewPublishPopupCompHOC {...attrs} />, document.getElementById('publish-print-goal-box'));
}

window.okrPublishPopup = okrPublishPopup;

class ViewPublishPopupComp extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            commentType: 0,
            commentStyling:0,
            printComp: {
                'm':1,
                'ws':0,
                'ag':0,
                'snr':0,
                'far':0,
             },
             goalStatus:{
                'openObjectives': props.goalStatus.indexOf('1') > -1 ? 1 : 0,
                'closedObjectives': props.goalStatus.indexOf('2') > -1 ? 1 : 0
             },
             endDate:props.endDate,
             startDate:props.startDate,
             exDate: props.exDate ? props.exDate : '',
             performance: props.performance ? props.performance : okrDetailConstants.FILTER_PROGRESS_DEFAULT,
             categories: props.categories ? props.categories : '',
             popupOpen:true,
             checkedValues: [],
             searchboxError:false,
             disabledChk:false
        };
        this.includeInPrint = this.includeInPrint.bind(this);
        this.canselPopup    = this.canselPopup.bind(this);
        this.renderPeopleSearchResults = this.renderPeopleSearchResults.bind(this);
        this.checkPeopleValue = this.checkPeopleValue.bind(this);
        this.removeItem = this.removeItem.bind(this);
        this.changeGoalStatus = this.changeGoalStatus.bind(this);
        this.popupCloseOnEsc = this.popupCloseOnEsc.bind(this);
    }

    componentDidMount(){
        window.addEventListener('keyup', this.popupCloseOnEsc, false);
    }
    componentWillUnmount(){
        window.removeEventListener('keyup', this.popupCloseOnEsc, false);
    }
    
    popupCloseOnEsc(event){
        if(event.keyCode === 27){
            this.canselPopup();
        }
    }

    includeInPrint(e,item){
        let chk = e.target.checked;
        let printComp = this.state.printComp;
        if(item == 'far' && !chk){
            Object.keys(printComp).forEach(v => printComp[v] = false)
            printComp.far = 1;
        }else if(item == 'far' && chk){
            printComp.m = 1;
            printComp.far = 0;
        }
        else{
            printComp.far = 0;
            printComp[`${item}`] = Number(!chk);
        }
        this.setState({printComp});
    }
    changeGoalStatus(e,item){
        let chk = e.target.checked;
        let goalStatus = this.state.goalStatus;
        goalStatus[`${item}`] = !chk;
        if(chk && !goalStatus.openObjectives && !goalStatus.closedObjectives){
            if(item == 'closedObjectives'){
                goalStatus.openObjectives = 1;
            }else{
                goalStatus.closedObjectives = 1;
            }
        }
        this.setState({goalStatus});
       
    }

    getGoalStatusString(g)
    {
        let status = [];
        if(g.openObjectives){
            status.push(1);
        }
        if(g.closedObjectives){
            status.push(2);
        }
        if(!g.openObjectives && !g.closedObjectives){
            status.push(1);
        }
        return status.join(',');
    }

    submitToPrint(){
        let url = wbConfig.baseUrl + '/goal/previewGoal';
        let goalStatus = this.state.goalStatus;
        let team_people_list = this.state.checkedValues;
        if(team_people_list.length == 0 && this.props.showSearch){
            this.setState({searchboxError:true});
        }else{
            let params = this.state.printComp || {};
            params.teamId = this.props.teamId;
            params.userId = this.props.userId;
            params.source = this.props.source;
            params.c = this.state.commentType; 
            params.commentStyling = this.state.commentStyling;
            params.endDate = this.state.endDate;
            params.startDate = this.state.startDate;
            params.performance = this.state.performance;
            params.categories = this.state.categories;
            params.customFields = this.props.customFields;
            if (this.props.exDate == 1) {
                params.exDate = this.props.exDate;
            }
            if(this.props.directDoted != 'undefined' && this.props.directDoted == 1){
                params.directDoted = this.props.directDoted;
                params[okrDetailConstants.HIDE_EMPTY_OKRS_EXPORT] = 1;
            }
            if (typeof this.props.overdueKR !== 'undefined' && this.props.overdueKR) {
                params.overdueKR = 1;
            }
            if (typeof this.props.custom_tag_id !== 'undefined' && this.props.custom_tag_id) {
                params.custom_tag_id = this.props.custom_tag_id;
            }
            params.goalStatus = this.getGoalStatusString(goalStatus);
            team_people_list = team_people_list.map(c => {
                return c.itemId;
            })
            if(this.props.showSearch){
                params.team_people_list = team_people_list.join(",");
            }
            if(typeof this.props.manageOkr !== 'undefined' && this.props.manageOkr){
                params.manageOkr = this.props.manageOkr;
            }
            if(typeof this.props.filterMap !== 'undefined' && this.props.filterMap == 1){
                params.filterMap = this.props.filterMap;
            }
            if (typeof this.props.previewBackUrl === 'string' && this.props.previewBackUrl !== '') {
                params[okrDetailConstants.PREVIEW_GOAL_BACK_URL] = this.props.previewBackUrl;
            }
            this.setState({popupOpen:false});
            
            let reference = '';
            if(params.directDoted != 'undefined' && params.directDoted == 1 ){
                reference = 'MY_DIRECTS_OKRS';
            }
            if(params.source != 'undefined' && params.source == 'workstreams' ){
                reference = 'TEAM_OKR';
            }
            if(params.source != 'undefined' && params.source == 'team' && params.teamId  ){
                reference = 'OKR_JUMP_TO';
            }
            if(params.source != 'undefined' && params.source == 'goal' ){
                reference = 'MY_OKR';
            }
            if(params.source != 'undefined' && params.source == 'goal' &&  params.team_people_list != 'undefined' && params.team_people_list ){
                reference = 'HEATMAP';
            }
            let goalServices = new GoalServices();
            goalServices.firePushAnalyticsData({ pageRef: 'EXPORT_OKR', refSrc: reference });
            ajaxPageLoad(url, 'POST', params, this.props.container , undefined,this.closePublishGoalBox);
        }
    }
    closePublishGoalBox(){
        $('#preview_goal_btn').prop('disabled',false);
        activeLeftMenuId('');
    }
    canselPopup(){
        this.setState({popupOpen:false});
        if(typeof document.getElementById('goal-export-button') != 'undefined' && document.getElementById('goal-export-button')) {
            document.getElementById('goal-export-button').focus();
        }
    }
    checkPeopleValue(e, item, searchBoxInst) {
        if (item) {
            this.setState({searchboxError:false});
            let _this = this;
            let {  checkedValues } = this.state;
            let chk = e.target.checked;
            let itemId = item.typeName + "-" + item.id;
            if (chk) {
                let chkedItem = {
                    "itemId":itemId,
                    "item":item,
                };
                checkedValues = [...checkedValues, chkedItem];
            } else {
                checkedValues = checkedValues.filter(v => v.itemId != itemId);
            }
            this.setState({ checkedValues });
        }
    }
    renderPeopleSearchResults(values, searchboxInst) {
        if (values.length) {
            let attr = {};
            attr.checkedValues = this.state.checkedValues;
            attr.checkBoxProps = {
                onChange: this.checkPeopleValue
            };
            return values.map(v => (
                <PublishSearchBoxList
                    key={v.type + "_" + v.id}
                    row={v}
                    inst={searchboxInst}
                    attr={attr}
                />
            ));
        } else {
            return null;
        }
    }

    removeItem(e, item) {
        if (item) {
            let itemId = item.item.typeName + "-" + item.item.id;
            let checkedValues = this.state.checkedValues.filter(
                v => v.itemId != itemId
            );
            this.setState({checkedValues});
        }
    }

    radioButtonKeyboardHandler (e, block) {
        if (e.key === eventKeyConstants.ARROWUP || e.key === eventKeyConstants.ARROWLEFT) {
            e.preventDefault();
            if(block) {
                if (e.target.id == "commentInLine") {
                    this.setState({
                        commentStyling: 1
                    }, () => {
                        document.getElementById("commentsAtBottom").focus();
                    });
                } else if (e.target.id == "commentsAtBottom") {
                    this.setState({
                        commentStyling: 0
                    }, () => {
                        document.getElementById("commentInLine").focus();
                    });
                }
            }
            if (e.target.id == "lastComment") {
                this.setState({
                    commentType: 0
                }, () => {
                    document.getElementById("excludeComments").focus();
                });
            } else if (e.target.id == "allComments") {
                this.setState({
                    commentType: 1
                }, () => {
                    document.getElementById("lastComment").focus();
                });
            } else if (e.target.id == "excludeComments") {
                this.setState({
                    commentType: 2
                }, () => {
                    document.getElementById("allComments").focus();
                });
            }
        } else if (e.key === eventKeyConstants.ARROWDOWN || e.key === eventKeyConstants.ARROWRIGHT) {
            e.preventDefault();
            if(block) {
                if (e.target.id == "commentInLine") {
                    this.setState({
                        commentStyling: 1
                    }, () => {
                        document.getElementById("commentsAtBottom").focus();
                    });
                } else if (e.target.id == "commentsAtBottom") {
                    this.setState({
                        commentStyling: 0
                    }, () => {
                        document.getElementById("commentInLine").focus();
                    });
                }
            }
            if (e.target.id == "lastComment") {
                this.setState({
                    commentType: 2
                }, () => {
                    document.getElementById("allComments").focus();
                });
            } else if (e.target.id == "allComments") {
                this.setState({
                    commentType: 0
                }, () => {
                    document.getElementById("excludeComments").focus();
                });
            } else if (e.target.id == "excludeComments") {
                this.setState({
                    commentType: 1
                }, () => {
                    document.getElementById("lastComment").focus();
                });
            }
        }
    }

    render(){
        let commentType = this.state.commentType;
        let showStyling = !!commentType;
        let commentStyling = this.state.commentStyling;
        let {printComp} = this.state;
        let showSearch = this.props.showSearch;
        let widtClass = showSearch == true ? 'widthShowSearch' : 'widthHideSearch';
        let checkedValues = this.state.checkedValues;
        let goalStatus = this.state.goalStatus;
        let searchboxError = this.state.searchboxError;
        let disabledChk = printComp.far == 1 ? true : false;
        let disabledClass = printComp.far == 1  ? 'opacity5 ' : "";  
        const executeModule = (typeof wbConfig.enableModules.execute !== 'undefined' && wbConfig.enableModules.execute) ? true : false;      
        const {t} = this.props;
        return (
            <ThemeProvider>
            <StyledModal
                title={t('Export or Print')}
                isOpen={this.state.popupOpen}
                dismissLabel={t("Cancel")}
                onDismiss={(e) => this.canselPopup()}
                onSubmit={(e) => this.submitToPrint()}
                submitLabel={t("Preview")}
                data-testid="exportmodal-view-as-table"
                className="export-modal-cls"
            >
                <div id="publish-print-goal-popup">
                    <div className="popupContent" style={{borderBottom: 'none'}} >
                        <div className="contentWrap">
                            <div className="includeBlock">
                                <fieldset>
                                    <legend className="popup-sub-title">
                                        {t('What do you want to include?')}
                                    </legend>
                                    <div className="fieldcontent">
                                        <div 
                                            aria-checked={printComp.m == 1}
                                            checked={printComp.m == 1}
                                            className={"print-publish-checkbox " + disabledClass + (printComp.m ? " checkbox-checked" : " checkbox-not-checked")}
                                            id="key_results"
                                            onClick={(e)=>{if(!disabledChk) this.includeInPrint(e,'m')}}
                                            onKeyDown={(e) => {
                                                KeyDownEvent(e, ()=>this.includeInPrint(e,'m'), false, true)
                                            }}
                                            role="checkbox"
                                            tabIndex={(!disabledChk) ? "0" : ''}
                                            aria-labelledby="key_results_lbl"
                                        />
                                        <label className={"inputLanles " + disabledClass} id="key_results_lbl" >
                                            {t("Key results")}
                                        </label>
                                    </div>
                                    <div className="fieldcontent">
                                        <div 
                                            aria-checked={printComp.snr == 1}
                                            checked={printComp.snr == 1}
                                            className={"print-publish-checkbox " + disabledClass + (printComp.snr ? " checkbox-checked" : " checkbox-not-checked")}
                                            id="nested_key_results"
                                            onClick={(e)=>{if(!disabledChk) this.includeInPrint(e,'snr')}}
                                            onKeyDown={(e) => {
                                                KeyDownEvent(e, ()=>this.includeInPrint(e,'snr'), false, true)
                                            }}
                                            role="checkbox"
                                            tabIndex={(!disabledChk) ? "0" : ''}
                                            aria-labelledby="nested_key_results_lbl"
                                        />
                                        <label className={"inputLanles " + disabledClass} id ="nested_key_results_lbl">
                                            {`${t('Rolled-up key results')}`}
                                        </label>
                                    </div>
                                    { executeModule && <div className="fieldcontent">
                                        <div 
                                            aria-checked={printComp.ws == 1}
                                            checked={printComp.ws == 1}
                                            className={"print-publish-checkbox " + disabledClass + (printComp.ws ? " checkbox-checked" : " checkbox-not-checked")}
                                            id="workstream_summary"
                                            onClick={(e)=>{if(!disabledChk) this.includeInPrint(e,'ws')}}
                                            onKeyDown={(e) => {
                                                KeyDownEvent(e, ()=>this.includeInPrint(e,'ws'), false, true)
                                            }}
                                            role="checkbox"
                                            tabIndex={(!disabledChk) ? "0" : ''}
                                            aria-labelledby="workstream_summary_lbl"
                                        />
                                        <label className={"inputLanles " + disabledClass} id="workstream_summary_lbl" >
                                            {t('Workstream summary')}
                                        </label>
                                    </div>
                                    } 
                                    <div className="fieldcontent">
                                        <div 
                                            aria-checked={printComp.ag == 1}
                                            checked={printComp.ag == 1}
                                            className={"print-publish-checkbox " + disabledClass + (printComp.ag ? " checkbox-checked" : " checkbox-not-checked")}
                                            id="one_level_alignment"
                                            onClick={(e)=>{if(!disabledChk) this.includeInPrint(e,'ag')}}
                                            onKeyDown={(e) => {
                                                KeyDownEvent(e, ()=>this.includeInPrint(e,'ag'), false, true)
                                            }}
                                            role="checkbox"
                                            tabIndex={(!disabledChk) ? "0" : ''}
                                            aria-labelledby="one_level_alignment_lbl"
                                        />
                                        <label className={"inputLanles " + disabledClass} id="one_level_alignment_lbl" >
                                            {t('One-level alignment')}
                                        </label>
                                    </div>
                                </fieldset>
                                <fieldset>
                                    <legend className="popup-sub-title popup-sub-title-comments">{t('What comments do you want to include?')}</legend>
                                    <div className="commentsBlock">
                                    <div className="commentsRadioBlock" role="radiogroup">
                                        <div className=" marginTop4point5 commentType">
                                            <div 
                                                aria-checked={commentType == 1}
                                                className={"print-publish-radio " + disabledClass + (commentType == 1 ? " radio-checked" : " radio-not-checked")}
                                                id="lastComment"
                                                onClick={e => {if(!disabledChk) this.setState({commentType:1}) }}
                                                onKeyDown={(e) => { this.radioButtonKeyboardHandler(e, false) }}
                                                role="radio"
                                                tabIndex={(commentType == 1 && !disabledChk) ? "0" : ''}
                                                aria-labelledby="lastComment_lbl"
                                            />
                                            <label id="lastComment_lbl" className={"inputLanles " + disabledClass}>
                                                {t('Last comment')}
                                            </label>
                                        </div>
                                        <div className=" marginTop4point5 commentType">
                                            <div 
                                                aria-checked={commentType == 2}
                                                className={"print-publish-radio " + disabledClass + (commentType == 2 ? " radio-checked" : " radio-not-checked")}
                                                id="allComments"
                                                onClick={e => {if(!disabledChk)this.setState({commentType:2}) } }
                                                onKeyDown={(e) => { this.radioButtonKeyboardHandler(e, false) }}
                                                role="radio"
                                                tabIndex={(commentType == 2  && !disabledChk) ? "0" : ''}
                                                aria-labelledby="allComments_lbl"
                                            />
                                            <label id="allComments_lbl" className={"inputLanles " + disabledClass}>
                                                {t('All comments')}
                                            </label>
                                        </div>
                                        <div className=" marginTop4point5 commentType">
                                            <div 
                                                aria-checked={commentType == 0}
                                                className={"print-publish-radio " + disabledClass + (commentType == 0 ? " radio-checked" : " radio-not-checked")}
                                                id="excludeComments"
                                                onClick={e => {if(!disabledChk) this.setState({commentType:0}) } }
                                                onKeyDown={(e) => { this.radioButtonKeyboardHandler(e, false) }}
                                                data-disabled={disabledChk}
                                                role="radio"
                                                tabIndex={(commentType == 0  && !disabledChk) ? "0" : ''}
                                                aria-labelledby="excludeComments_lbl"
                                            />
                                            <label id="excludeComments_lbl" className={"inputLanles " + disabledClass}>
                                                {t('Exclude comments')}
                                            </label>
                                        </div>
                                    </div>
                                    { showStyling &&
                                        <div className="commentStylingWrap" role="radiogroup">
                                            <fieldset>
                                                <legend className="commentStyling">{t('Comment styling')}</legend>
                                                <div className="stylingBlock">
                                                    <div className=" marginTop4point5 stylingBlock1">
                                                        <div 
                                                            aria-checked={commentStyling == 0}
                                                            className={"print-publish-radio " + disabledClass + (commentStyling == 0 ? " radio-checked" : " radio-not-checked")}
                                                            id="commentInLine"
                                                            onClick={e => {if(!disabledChk) this.setState({commentStyling:0}) } }
                                                            onKeyDown={(e) => { this.radioButtonKeyboardHandler(e, true) }}
                                                            data-disabled={disabledChk}
                                                            role="radio"
                                                            tabIndex={(commentStyling == 0  && !disabledChk) ? "0" : ''}
                                                            aria-labelledby="commentInLine_lbl"
                                                        />
                                                        <label id="commentInLine_lbl" className={"inputLanles " + disabledClass}>
                                                            {t('Comments in-line')}
                                                        </label>
                                                    </div>
                                                    <div className=" marginTop4point5 stylingBlock2">
                                                        <div 
                                                            aria-checked={commentStyling == 1}
                                                            className={"print-publish-radio " + disabledClass + (commentStyling == 1 ? " radio-checked" : " radio-not-checked")}
                                                            id="commentsAtBottom"
                                                            onClick={e => {if(!disabledChk) this.setState({commentStyling:1}) } }
                                                            onKeyDown={(e) => { this.radioButtonKeyboardHandler(e, true) }}
                                                            data-disabled={disabledChk}
                                                            role="radio"
                                                            tabIndex={(commentStyling == 1  && !disabledChk) ? "0" : ''}
                                                            aria-labelledby="commentsAtBottom_lbl"
                                                        />
                                                        <label id="commentsAtBottom_lbl" className={"inputLanles " + disabledClass}>
                                                        {t('Comments at bottom of each OKR')}
                                                        </label>
                                                    </div>
                                                </div>
                                            </fieldset>
                                        </div>
                                    }
                                </div>
                                </fieldset>
                                { showSearch &&
                                <div className="commentBlockAdditional">
                                    <fieldset>
                                        <legend className="commentStyling">{t('Or')}</legend>
                                        <div className="fieldcontent">
                                            <div 
                                                aria-checked={printComp.far == 1}
                                                checked={printComp.far == 1}
                                                className={"print-publish-checkbox " + (printComp.far ? " checkbox-checked" : " checkbox-not-checked")}
                                                id="full_alignment_report"
                                                onClick={(e)=>this.includeInPrint(e,'far')}
                                                onKeyDown={(e) => {
                                                    KeyDownEvent(e, ()=>this.includeInPrint(e,'far'), false, true)
                                                }}
                                                role="checkbox"
                                                tabIndex="0"
                                                aria-labelledby="full_alignment_report_lbl"
                                            />
                                            <label className="inputLanles" id="full_alignment_report_lbl" >
                                               {t('Full alignment report')}
                                            </label>
                                        </div>
                                    </fieldset>
                                    <fieldset className="objectiveStyling">
                                        <legend className="commentStyling">{t('Include')}</legend>
                                        <div className="fieldcontent block50">
                                            <div 
                                                aria-checked={goalStatus.openObjectives == 1}
                                                checked={goalStatus.openObjectives == 1}
                                                className={"print-publish-checkbox " + (goalStatus.openObjectives ? " checkbox-checked" : " checkbox-not-checked")}
                                                id="open_objectives"
                                                onClick={(e)=>this.changeGoalStatus(e,'openObjectives')}
                                                onKeyDown={(e) => {
                                                    KeyDownEvent(e, ()=>this.changeGoalStatus(e,'openObjectives'), false, true)
                                                }}
                                                role="checkbox"
                                                tabIndex="0"
                                                aria-labelledby="open_objectives_lbl"
                                            />
                                            <label className="inputLanles" id="open_objectives_lbl" >
                                                {`${t("Open objectives")}`}
                                            </label>
                                        </div>
                                        <div className="fieldcontent block50">
                                            <div 
                                                aria-checked={goalStatus.closedObjectives == 1}
                                                checked={goalStatus.closedObjectives == 1}
                                                className={"print-publish-checkbox " + (goalStatus.closedObjectives ? " checkbox-checked" : " checkbox-not-checked")}
                                                id="closed_objectives"
                                                onClick={(e)=>this.changeGoalStatus(e,'closedObjectives')}
                                                onKeyDown={(e) => {
                                                    KeyDownEvent(e, ()=>this.changeGoalStatus(e,'closedObjectives'), false, true)
                                                }}
                                                role="checkbox"
                                                tabIndex="0"
                                                aria-labelledby="closed_objectives_lbl"
                                            />
                                            <label className="inputLanles" id="closed_objectives_lbl" >
                                                {`${t("Closed Objectives")}`}
                                            </label>
                                        </div>
                                        
                                    </fieldset>
                                </div>
                                }
                            </div>
                        </div>
                        { showSearch &&
                            <div className="serachBlock">
                                <div className="contentWrap"> 
                                    <label htmlFor="search-input-box" data-testid="search-input-box" className="searchlable">{t('Include OKRs from teams, people, category, or by name')}:</label>
                                    <div className="wrapSearchPopup">
                                        <SearchBoxComp
                                            minLength="2"
                                            wrapperClass="cascade-results-people"
                                            url={"goal/publishGoalUserSearch?s=" + this.getGoalStatusString(this.state.goalStatus)}
                                            inputProps={{
                                                placeholder: `${t('Search for teams, people, objectives, or categories')}`,
                                                className: searchboxError ? 'errorBorder': "",
                                            }}
                                            renderResultComp={this.renderPeopleSearchResults}
                                        />
                                    </div>

                                    <div>
                                        <div className="fieldcontent">
                                            <fieldset>
                                                <legend className="wherekrDataCome">{t('Selected')}:</legend>
                                                {checkedValues.length ? (
                                                <div className="seleted-table-wrap">
                                                    {checkedValues.map(r => (
                                                    r.item.type == 1 ? 
                                                        <RollUpTableComp
                                                            key={r.item.typeName + "-" + r.item.id}
                                                            type="publishOkrSel"
                                                            tableClass="rollup-kr-table"
                                                            row={r}
                                                            removeItem={this.removeItem}
                                                        />   

                                                    : 
                                                    <TeamSelectedComp
                                                        isNew={false}
                                                        key={r.item.typeName + "-" + r.item.id}
                                                        tableClass="seleted-table"
                                                        row={r}
                                                        removeItem={this.removeItem}/> 
                                                    ))
                                                    }
                                                </div>
                                                ) : ("")}
                                            </fieldset>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }
                    </div>
                </div>
         </StyledModal>
         </ThemeProvider>
        )
    }

}

const ViewPublishPopupCompHOC = withTranslation()(ViewPublishPopupComp)